<template>
      <div class="gradeEdit">
        <v-breadcrumbs>
          <v-breadcrumbs-item :exact="true" :to="{ name: 'home', params: {} }"
            >Home</v-breadcrumbs-item
          >
          <v-breadcrumbs-divider>/</v-breadcrumbs-divider>
          <v-breadcrumbs-item :exact="true" :to="{ name: 'grade', params: {} }">
          Grade
          </v-breadcrumbs-item>
          <v-breadcrumbs-divider>/</v-breadcrumbs-divider>
          <v-breadcrumbs-item :to="{ name: 'gradeEdit', params:{id: id} }">
            Edit Grade
          </v-breadcrumbs-item>
        </v-breadcrumbs>

        <v-card>
          <v-card-title>Edit Grade</v-card-title>
          <v-card-text>
            <grade-form :id="id"></grade-form>
          </v-card-text>
        </v-card>
      </div>
    </template>

    <script>
    import GradeForm from './GradeForm.vue';

    export default {
      name: 'grade',
      data () {
        return {
          id: null
        }
      },
      components: {
        GradeForm
      },
      created () {
          this.id = this.$route.params.id;
          this.$emit("showParent", false);
      }
    }
    </script>
    